var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',_vm._g(_vm._b({attrs:{"value":_vm.value,"editor":_vm.editor,"config":_vm.editorConfig},on:{"input":_vm.onInput}},'ckeditor',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }